import { useQuery } from '@apollo/client';
import React, { useState, useEffect } from 'react';
import { FUND } from 'modules/fund/queries';
import { EeCard } from 'pages/Scenarios/components/EeCard';

export const Actual = (props: any) => {
  const { loading, error, data } = useQuery(FUND, {
    variables: { id: props.fundId },
  });
  const [fundDetails, setFundDetails] = useState([] as any);

  useEffect(() => {
    if (!loading && data && data.fund) {
      const { fund } = data;
      const currencySign = window.GLOBAL_CONFIG.CURRENCIES[fund.currency].sign;
      const fields: any[] = [
        {
          title: 'INVESTED CAPITAL',
          content: `${fund.investedCapital}`,
          formatProps: {
            thousandSeparator: true,
            prefix: currencySign,
            decimalScale: 0,
          },
        },
        {
          title: 'BOOK VALUE',
          content: `${Math.round(fund.bookValue)}`,
          formatProps: {
            thousandSeparator: true,
            prefix: currencySign,
            decimalScale: 0,
          },
        },
        {
          title: 'Realized Value',
          content: `${fund.realizedValue}`,
          formatProps: {
            thousandSeparator: true,
            prefix: currencySign,
            decimalScale: 0,
          },
        },
        {
          title: 'GROSS IRR',
          content: fund.grossIrr * 100,
          formatProps: {
            suffix: '%',
            decimalScale: 2,
          },
        },
        {
          title: 'GROSS MULTIPLE',
          content: fund.grossMultiple,
          formatProps: {
            suffix: 'x',
            decimalScale: 2,
          },
        },
      ];

      setFundDetails(fields);
    }
  }, [loading, error, data]);

  return <EeCard title="Actual" cardInfo={fundDetails} />;
};
